import { Button, Col, Row, Space, Typography } from "antd";
import { ArrowLeftOutlined, ArrowsAltOutlined } from "@ant-design/icons";
import { useState } from "react";
import PropTypes from "prop-types";
import { Divider, Select, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import { TextViewerPre } from "../text-viewer-pre/TextViewerPre";
import { TextViewerModal } from "../text-viewer-modal/TextViewerModal";
import { PdfViewer } from "../pdf-viewer/PdfViewer";
import { Logo64 } from "../../../../../../assets/index";
import { useSettingsStore } from "../../store/settings-store";
import {
  formFieldValues,
  outputModeOptions,
  processingModeOptions,
} from "../../constants";
import { SpinnerLoader } from "../../../../../../components/widgets/spinner-loader/SpinnerLoader";

function Home({ beforeUpload, onSubmit }) {
  const [openTextViewer, setOpenTextViewer] = useState(false);
  const {
    formData,
    fileData,
    isLoading,
    isSubmitted,
    updateSettingsState,
    sampleName,
  } = useSettingsStore();

  const handleChange = (fieldName, value) => {
    const newFormData = { ...formData };
    newFormData[fieldName] = value;
    updateSettingsState({ formData: newFormData });
  };
  const handleBack = () => {
    updateSettingsState({ isSubmitted: false });
  };

  return (
    <>
      <Space className="playground-settings-container">
        {isSubmitted && (
          <>
            <Space>
              <ArrowLeftOutlined onClick={() => handleBack()} />
              <Typography.Text
                className="header-singup-msg header-max-text-width"
                ellipsis
              >
                {fileData?.name || "Document not uploaded"}
              </Typography.Text>
              <Typography.Text className="header-singup-msg font-12">
                Processing Mode
              </Typography.Text>
              <Select
                size="small"
                className="header-dropdown custom-button-primary-head"
                name="processing_mode"
                options={processingModeOptions}
                value={formData?.processing_mode}
                onChange={(value) =>
                  handleChange(formFieldValues.processingMode, value)
                }
                disabled={isLoading}
              />
            </Space>
            <Space>
              <Typography.Text className="header-singup-msg font-12">
                Output Mode
              </Typography.Text>
              <Select
                size="small"
                className="header-dropdown custom-button-primary-head"
                name="output_mode"
                options={outputModeOptions}
                value={formData?.output_mode}
                onChange={(value) =>
                  handleChange(formFieldValues.outputMode, value)
                }
                disabled={isLoading}
              />
            </Space>
            <Divider className="divider-light" type="vertical" />
            <Space>
              <Upload
                multiple={false}
                maxCount={1}
                beforeUpload={beforeUpload}
                fileList={[]}
                disabled={isLoading}
                accept=".pdf"
              >
                <Button
                  size="small"
                  className="custom-button-primary-head"
                  disabled={isLoading}
                >
                  <UploadOutlined />
                </Button>
              </Upload>
            </Space>
            <Divider className="divider-light" type="vertical" />
            <Button
              size="small"
              className="custom-button-primary-head"
              onClick={onSubmit}
              disabled={isLoading}
            >
              <Space>
                {isLoading ? (
                  <SpinnerLoader size="small" />
                ) : (
                  <div className="center">
                    <Logo64 height={15} width={"auto"} />
                  </div>
                )}
                Extract
              </Space>
            </Button>
          </>
        )}
      </Space>
      <Row className="height-96 overflow-hidden pad-12" gutter={10}>
        <Col span={12} className="height-100 overflow-hidden">
          <div className="overflow-hidden height-100 flex-col">
            <div className="flex-1 overflow-hidden">
              <PdfViewer />
            </div>
          </div>
        </Col>
        <Col span={12} className="height-100 overflow-hidden">
          <div className="overflow-hidden height-100 flex-col">
            <div className="flex-1 overflow-hidden extract-container">
              <div className="height-100 flex-col overflow-hidden">
                <div className="border-bottom home-extract-head pad-8">
                  <Space size={5}>
                    <Typography.Text strong>
                      Extracted Text{sampleName && `: ${sampleName}`}
                    </Typography.Text>
                  </Space>
                  <div className="right-corner home-btn-right">
                    <Button
                      type="text"
                      size="small"
                      onClick={() => setOpenTextViewer(true)}
                    >
                      <ArrowsAltOutlined />
                    </Button>
                  </div>
                </div>
                <div className="flex-1 overflow-hidden">
                  <TextViewerPre />
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <TextViewerModal open={openTextViewer} setOpen={setOpenTextViewer} />
    </>
  );
}

Home.propTypes = {
  beforeUpload: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export { Home };
